<app-shell-admin-warning-banner></app-shell-admin-warning-banner>
<ng-container *ngIf="viewModel$ | async as viewModel">
	<dx-data-grid height="calc(100vh - 320px)"
		[dataSource]="viewModel.dataSource"
		[remoteOperations]="true"
		[showBorders]="true"
		(onRowRemoving)="rowRemoving($event, viewModel)"
		(onEditorPreparing)="onEditorPreparing($event)"
	>
		<dxo-sorting mode="multiple"></dxo-sorting>
		<dxo-pager [showPageSizeSelector]="true"></dxo-pager>
		<dxo-paging [enabled]="true" [pageSize]="25"></dxo-paging>
		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="true" [allowDeleting]="true"></dxo-editing>
		<dxo-search-panel [visible]="true"></dxo-search-panel>

		<dxi-column
			dataField="id"
			caption="ID"
			[visible]="false"
		>
		</dxi-column>
		<dxi-column
			dataField="createdOn"
			dataType="datetime"
			caption="Created on"
		>
		</dxi-column>
		<dxi-column
			dataField="userName"
			caption="Username"
		>
		</dxi-column>
		<dxi-column
			dataField="firstName"
			caption="First name"
		>
		</dxi-column>
		<dxi-column
			dataField="lastName"
			caption="Last name"
		>
		</dxi-column>
		<dxi-column
			dataField="email"
			caption="Email"
		>
		</dxi-column>
	</dx-data-grid>
</ng-container>
